// client/src/pages/Dashboard.js
// client/src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import StatsModal from '../components/modals/StatsModal';
import { QRCodeSVG as QRCode } from 'qrcode.react';
import { useUser } from '@clerk/clerk-react';
import qrcode from 'qrcode';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import BulkQRStatsModal from '../components/modals/BulkQRStatsModal';
import BulkQRSection from '../components/BulkQRSection';
import { trackEvent } from '../utils/analytics';
import UpgradeModal from '../components/modals/UpgradeModal';




// import BulkQRStatsModal from './BulkQRStatsModal'; // Adjust the path as needed


function Dashboard() {
  const { isSignedIn, user } = useUser();

  const [account, setAccount] = useState(null);
  const [qrCodes, setQrCodes] = useState([]);
  const [linkShorts, setLinkShorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('all'); // 'all', 'qr', 'links', 'bulk'
  const [selectedItem, setSelectedItem] = useState(null);
  const [statsModalOpen, setStatsModalOpen] = useState(false);
  const [statsItemType, setStatsItemType] = useState(null);
  const [daysRemaining, setDaysRemaining] = useState(14); // Default to 14 days
  const [bulkGroupsData, setBulkGroupsData] = useState({});
  const [name, setName] = useState('');
    const [bulkGroup, setBulkGroup] = useState(null);
    const [nameMapping, setNameMapping] = useState({});
    const [selectedBulkGroup, setSelectedBulkGroup] = useState(null);
    const [bulkStatsOpen, setBulkStatsOpen] = useState(false);
    const [bulkStats, setBulkStats] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadSuccess, setSuccess] = useState('');

    const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
    const [upgradeModalType, setUpgradeModalType] = useState('stats'); 


    const fetchData = async () => {
      // Skip fetching if user is not available yet
      if (!user) {
        console.log('User not initialized yet, skipping data fetch');
        return;
      }
    
      try {
        console.log('Fetching data for clerk ID:', user.id);
        
        // First, try to directly fetch the user's account
        console.log(`Finding user with clerk ID: ${user.id}`);
        try {
          const userResponse = await fetch(`/api/users/by-clerk/${user.id}`);
          
          if (userResponse.ok) {
            const userData = await userResponse.json();
            console.log('User data:', userData);
            
            if (userData && userData.account_id) {
              const accountId = userData.account_id;
              console.log(`Found account ID from user lookup: ${accountId}`);
              
              // Fetch account details
              const accountResponse = await fetch(`/api/account/${accountId}`);
              if (accountResponse.ok) {
                const accountData = await accountResponse.json();
                console.log('Account data successfully fetched:', accountData);
                setAccount(accountData);
                
                // Calculate days remaining if on free plan
                if (accountData.plan === 'free_trial') {
                  const creationDate = new Date(accountData.createdAt);
                  const currentDate = new Date();
                  const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                  const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                  setDaysRemaining(daysRemaining);
                  console.log('Days remaining on free plan:', daysRemaining);
                }
              }
            }
          }
        } catch (accountError) {
          console.error('Error fetching account:', accountError);
        }
        
        // Simplified approach - directly fetch resources by user ID first
        // This ensures we at least have content to show even if account lookup fails
        console.log('First trying direct user_id fetching for immediate results');
        
        const linkResponse = await fetch(`/api/linkshorts?user_id=${user.id}`);
        if (linkResponse.ok) {
          const linkData = await linkResponse.json();
          console.log(`Found ${linkData.length} link shorts with direct user_id method`);
          setLinkShorts(linkData);
          
          // If we have at least one link, try to get account from there
          if (linkData.length > 0 && linkData[0].account_id && !account) {
            const accountId = linkData[0].account_id;
            console.log(`Using account ID from link short: ${accountId}`);
            
            // Fetch account details
            const accountResponse = await fetch(`/api/account/${accountId}`);
            if (accountResponse.ok) {
              const accountData = await accountResponse.json();
              setAccount(accountData);
              
              // Calculate days remaining if on free plan
              if (accountData.plan === 'free_trial') {
                const creationDate = new Date(accountData.createdAt);
                const currentDate = new Date();
                const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                setDaysRemaining(daysRemaining);
              }
            }
          }
        }
        
        const qrResponse = await fetch(`/api/qrcodes?user_id=${user.id}`);
        if (qrResponse.ok) {
          const qrData = await qrResponse.json();
          console.log(`Found ${qrData.length} QR codes with direct user_id method`);
          setQrCodes(qrData);
          
          // If we have at least one QR code, try to get account from there
          if (qrData.length > 0 && qrData[0].account_id && !account) {
            const accountId = qrData[0].account_id;
            console.log(`Using account ID from QR code: ${accountId}`);
            
            // Fetch account details
            const accountResponse = await fetch(`/api/account/${accountId}`);
            if (accountResponse.ok) {
              const accountData = await accountResponse.json();
              setAccount(accountData);
              
              // Calculate days remaining if on free plan
              if (accountData.plan === 'free_trial') {
                const creationDate = new Date(accountData.createdAt);
                const currentDate = new Date();
                const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                setDaysRemaining(daysRemaining);
              }
            }
          }
        }
        
        // Try to find all resources by account_id if user lookup succeeded
        try {
          // First check if we found the user successfully above
          const userResponse = await fetch(`/api/users/by-clerk/${user.id}`);
          if (userResponse.ok) {
            const userData = await userResponse.json();
            
            if (userData && userData.account_id) {
              const accountId = userData.account_id;
              
              // Try to fetch all resources by account_id
              const accountLinksResponse = await fetch(`/api/linkshorts?account_id=${accountId}`);
              if (accountLinksResponse.ok) {
                const accountLinksData = await accountLinksResponse.json();
                console.log(`Found ${accountLinksData.length} link shorts for account`);
                if (accountLinksData.length > 0) {
                  setLinkShorts(accountLinksData);
                }
              }
              
              const accountQrResponse = await fetch(`/api/qrcodes?account_id=${accountId}`);
              if (accountQrResponse.ok) {
                const accountQrData = await accountQrResponse.json();
                console.log(`Found ${accountQrData.length} QR codes for account`);
                if (accountQrData.length > 0) {
                  setQrCodes(accountQrData);
                }
              }
            }
          }
        } catch (userLookupError) {
          console.error('Error during user/account lookup:', userLookupError);
          // We already have data from direct user_id fetching, so no need to do anything else
        }
      } catch (err) {
        console.error('Error in fetchData:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    
      if (user && account) {
        try {
          const accountId = account._id;
          const bulkResponse = await fetch(`/api/bulk-qrcodes?account_id=${accountId}`);
          if (bulkResponse.ok) {
            const bulkData = await bulkResponse.json();
            console.log(`Found ${bulkData.length} bulk groups for account`);
            
            // Create a mapping of bulk group IDs to their names
            const bulkGroupsMapping = {};
            bulkData.forEach(group => {
              if (group._id && group.name) {
                bulkGroupsMapping[group._id] = group.name;
              }
            });
            
            // Store this mapping
            setBulkGroupsData(bulkGroupsMapping);
          }
        } catch (error) {
          console.error('Error fetching bulk groups:', error);
        }
      }
    };
    


    useEffect(() => {
      if (isSignedIn) {
        fetchData();
        
        // Fire Google Ads conversion event when user logs in
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-17100390540/OVueCJe1issaEIyBjdo_',
            'value': 1.0,
            'currency': 'USD'
          });
        }
      } else {
        setLoading(false);
      }
    }, [isSignedIn, user]);


  useEffect(() => {
    // This runs after the dashboard has loaded and we have QR codes
    const fetchBulkGroupNames = async () => {
      // Get all unique bulk IDs from the QR codes
      const bulkIds = [...new Set(qrCodes.filter(qr => qr.bulk_id).map(qr => qr.bulk_id))];
      
      if (bulkIds.length === 0) return;
      
      console.log("Fetching names for bulk groups:", bulkIds);
      
      // Create a mapping to store bulk group names
      const nameMapping = {};
      
      // Fetch each bulk group's details
      for (const bulkId of bulkIds) {
        try {
          const response = await fetch(`/api/bulk-qrcodes/${bulkId}`);
          if (response.ok) {
            const data = await response.json();
            if (data.name) {
              nameMapping[bulkId] = data.name;
              console.log(`Bulk group ${bulkId} name: ${data.name}`);
            }
          }
        } catch (error) {
          console.error(`Error fetching bulk group ${bulkId}:`, error);
        }
      }
      
      // Save the mapping to state
      setNameMapping(nameMapping);
    };
    
    if (qrCodes.length > 0) {
      fetchBulkGroupNames();
    }
  }, [qrCodes]);


  // Banner visibility check
  useEffect(() => {
    if (account) {
      console.log('Banner visibility check:', {
        accountPlan: account.plan,
        shouldShowFreeBanner: account.plan === 'free_trial',
        shouldShowTrialBanner: account.plan === 'free_trial',
        renderCount: Math.random() // To track re-renders
      });
    }
  }, [account]);
  
  // Debug log to check account state
  useEffect(() => {
    console.log('Current account state:', account);
  }, [account, daysRemaining]);

  const fetchBulkGroups = async () => {
    try {
      setLoading(true);
      let endpoint = '';
      
      if (account && account._id) {
        endpoint = `/api/bulk-qrcodes?account_id=${account._id}`;
      } else if (user) {
        endpoint = `/api/bulk-qrcodes?user_id=${user.id}`;
      } else {
        return;
      }
      
      console.log('Fetching bulk groups from:', endpoint);
      const response = await fetch(endpoint);
      
      if (!response.ok) {
        console.error('Failed to fetch bulk groups:', response.status);
        return;
      }
      
      const data = await response.json();
      console.log(`Found ${data.length} bulk groups`);
      setBulkGroupsData(data);
    } catch (error) {
      console.error('Error fetching bulk groups:', error);
    } finally {
      setLoading(false);
    }
  };

  const openBulkStats = async (group) => {
    if (!group || !group._id) {
      console.error('Invalid bulk group provided to openBulkStats');
      return;
    }
    if (!account || account.plan === 'free_basic') {
      // Show upgrade modal instead of stats
      setUpgradeModalType('stats');
      setUpgradeModalOpen(true);
      return;
    }
    trackEvent('bulk_stats_view', {
      bulk_id: group._id,
      bulk_name: group.name || 'Unnamed Bulk Group',
      qr_count: group.count || 0
    });
    
    setSelectedBulkGroup(group);
    setBulkStatsOpen(true);
    
    try {
      // Fetch stats for the bulk group
      const response = await fetch(`/api/bulk-qrcodes/${group._id}/stats`);
      if (response.ok) {
        const data = await response.json();
        console.log("Bulk stats data:", data);
        setBulkStats(data);
      } else {
        console.error('Failed to fetch bulk stats');
      }
    } catch (error) {
      console.error('Error fetching bulk stats:', error);
    }
  };
// This function correctly handles the shape of the QR code during export
// Add this to the handleDownloadQR function in Dashboard.js
// Replace or modify the existing function

const handleDownloadQR = (qrCode) => {
  try {
    trackEvent('qr_download', {
      qr_id: qrCode._id,
      qr_name: qrCode.qr_name || 'Unnamed QR Code',
      qr_type: qrCode.qrType || 'url'
    });
    console.log("QR code data for download:", {
      id: qrCode._id,
      name: qrCode.qr_name,
      targetUrl: qrCode.targetUrl,
      qrType: qrCode.qrType,  // Make sure qrType is included
      showName: qrCode.showName,
      showURL: qrCode.showURL,
      shape: qrCode.shape,
      backgroundColor: qrCode.backgroundColor,
      foregroundColor: qrCode.foregroundColor,
      textColor: qrCode.textColor
    });

    // Get styling info
    const shape = qrCode.shape || 'square';
    const dotStyle = qrCode.dotStyle || shape;
    const bgColor = qrCode.backgroundColor || '#f1f1f4';
    const fgColor = qrCode.foregroundColor || '#000000';
    const textColor = qrCode.textColor || '#000000';
    
    // Create a high-resolution canvas
    const scaleFactor = 2;
    const baseSize = 800;
    const size = baseSize * scaleFactor;
    
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    
    // Enable high-quality image smoothing
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    
    // Scale all drawing operations
    ctx.scale(scaleFactor, scaleFactor);
    
    // Draw background with shape
    ctx.fillStyle = bgColor;
    if (shape === 'circle') {
      ctx.beginPath();
      ctx.arc(baseSize/2, baseSize/2, baseSize/2, 0, Math.PI * 2);
      ctx.fill();
    } else if (shape === 'rounded') {
      const radius = baseSize / 10;
      ctx.beginPath();
      ctx.moveTo(radius, 0);
      ctx.lineTo(baseSize - radius, 0);
      ctx.quadraticCurveTo(baseSize, 0, baseSize, radius);
      ctx.lineTo(baseSize, baseSize - radius);
      ctx.quadraticCurveTo(baseSize, baseSize, baseSize - radius, baseSize);
      ctx.lineTo(radius, baseSize);
      ctx.quadraticCurveTo(0, baseSize, 0, baseSize - radius);
      ctx.lineTo(0, radius);
      ctx.quadraticCurveTo(0, 0, radius, 0);
      ctx.fill();
    } else {
      ctx.fillRect(0, 0, baseSize, baseSize);
    }
    
    // Get QR data to generate
    let qrCodeContent = '';
    
    // Special handling for vCard QR codes
    if (qrCode.qrType === 'vcard') {
      // Use the targetUrl directly for vCards as it already contains the formatted vCard string
      qrCodeContent = qrCode.targetUrl;
      
      // For display purposes in the preview UI, extract the name from vCard if showURL is true
      if (qrCode.showURL) {
        // We'll overwrite this value later for the display text
        const nameMatch = qrCode.targetUrl.match(/FN:(.*?)(?:\r?\n|$)/);
        if (nameMatch && nameMatch[1]) {
          qrCode.displayText = `Contact: ${nameMatch[1].trim()}`;
        } else {
          qrCode.displayText = 'Contact Card';
        }
      }
    } else {
      // For other QR types, use the original URL or the short URL
      qrCodeContent = `${window.location.origin}/${qrCode.shortId}`;
    }
    
    // Use qrcode library to get QR code data
    const tempCanvas = document.createElement('canvas');
    
    qrcode.toCanvas(tempCanvas, qrCodeContent, {
      errorCorrectionLevel: 'H',
      margin: 0, 
      scale: 1,
      width: 100  // Small size to get data
    }, function(error) {
      if (error) {
        console.error("QR generation error:", error);
        alert("Could not generate QR code");
        return;
      }
      
      // Get QR code data
      const tempCtx = tempCanvas.getContext('2d');
      const qrData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
      const data = qrData.data;
      const moduleCount = tempCanvas.width;
      
      // Calculate dot size based on canvas size
      const moduleSize = Math.floor(baseSize * 0.7 / moduleCount);
      const startPoint = Math.floor((baseSize - (moduleCount * moduleSize)) / 2);
      
      // Draw custom dots
      ctx.fillStyle = fgColor;
      
      for (let y = 0; y < moduleCount; y++) {
        for (let x = 0; x < moduleCount; x++) {
          // Get pixel color (only check red channel since QR is black/white)
          const pixelIndex = (y * moduleCount + x) * 4;
          const isDark = data[pixelIndex] < 128;
          
          if (isDark) {
            const xPos = startPoint + x * moduleSize;
            const yPos = startPoint + y * moduleSize;
            
            // Draw based on selected dot style
            if (dotStyle === 'circle') {
              // Draw circular dots
              ctx.beginPath();
              ctx.arc(
                xPos + moduleSize / 2, 
                yPos + moduleSize / 2, 
                moduleSize / 2 * 0.9, // Slightly smaller for spacing
                0, 
                Math.PI * 2
              );
              ctx.fill();
            } else if (dotStyle === 'rounded') {
              // Draw rounded square dots
              const radius = moduleSize / 4;
              ctx.beginPath();
              ctx.moveTo(xPos + radius, yPos);
              ctx.lineTo(xPos + moduleSize - radius, yPos);
              ctx.quadraticCurveTo(xPos + moduleSize, yPos, xPos + moduleSize, yPos + radius);
              ctx.lineTo(xPos + moduleSize, yPos + moduleSize - radius);
              ctx.quadraticCurveTo(xPos + moduleSize, yPos + moduleSize, xPos + moduleSize - radius, yPos + moduleSize);
              ctx.lineTo(xPos + radius, yPos + moduleSize);
              ctx.quadraticCurveTo(xPos, yPos + moduleSize, xPos, yPos + moduleSize - radius);
              ctx.lineTo(xPos, yPos + radius);
              ctx.quadraticCurveTo(xPos, yPos, xPos + radius, yPos);
              ctx.fill();
            } else {
              // Default square dots
              ctx.fillRect(xPos, yPos, moduleSize, moduleSize);
            }
          }
        }
      }
      
      // Check if there's a logo to add
      if (qrCode.logo) {
        const logoImg = new Image();
        logoImg.crossOrigin = "Anonymous";
        
        logoImg.onload = function() {
          // Calculate logo size and position
          const logoSize = baseSize * 0.12;
          const logoX = (baseSize - logoSize) / 2;
          const logoY = (baseSize - logoSize) / 2;
          
          // Draw appropriate background based on shape
          ctx.fillStyle = bgColor;
          
          // Match the logo background shape to the QR code shape
          if (shape === 'circle') {
            const padding = baseSize * 0.03;
            // For circle, use circular background for logo
            ctx.beginPath();
            ctx.arc(
              logoX + (logoSize / 2), 
              logoY + (logoSize / 2), 
              (logoSize / 2) + padding,
              0,
              Math.PI * 2
            );
            ctx.fill();
          } else if (shape === 'rounded') {
            // For rounded QR codes, use rounded rectangle for logo background
            const padding = baseSize * 0.012;
            const paddedX = logoX - padding;
            const paddedY = logoY - padding;
            const paddedWidth = logoSize + (padding * 2);
            const paddedHeight = logoSize + (padding * 2);
            const cornerRadius = paddedWidth * 0.2; // 20% of width for rounded corners
            
            // Draw rounded rectangle
            ctx.beginPath();
            ctx.moveTo(paddedX + cornerRadius, paddedY);
            ctx.lineTo(paddedX + paddedWidth - cornerRadius, paddedY);
            ctx.quadraticCurveTo(paddedX + paddedWidth, paddedY, paddedX + paddedWidth, paddedY + cornerRadius);
            ctx.lineTo(paddedX + paddedWidth, paddedY + paddedHeight - cornerRadius);
            ctx.quadraticCurveTo(paddedX + paddedWidth, paddedY + paddedHeight, paddedX + paddedWidth - cornerRadius, paddedY + paddedHeight);
            ctx.lineTo(paddedX + cornerRadius, paddedY + paddedHeight);
            ctx.quadraticCurveTo(paddedX, paddedY + paddedHeight, paddedX, paddedY + paddedHeight - cornerRadius);
            ctx.lineTo(paddedX, paddedY + cornerRadius);
            ctx.quadraticCurveTo(paddedX, paddedY, paddedX + cornerRadius, paddedY);
            ctx.closePath();
            ctx.fill();
          } else {
            // For square QR codes, use square background for logo
            const padding = baseSize * 0.009;
            ctx.fillRect(
              logoX - padding, 
              logoY - padding, 
              logoSize + (padding * 2), 
              logoSize + (padding * 2)
            );
          }
          
          // Draw logo
          ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize);
          
          // Finish the download
          finishDownload();
          
        };
        
        logoImg.onerror = function() {
          console.error("Error loading logo:", qrCode.logo);
          // Continue without logo
          finishDownload();
        };
        
        // Set the source - make sure to use the full URL if it's a relative path
        if (qrCode.logo.startsWith('http')) {
          logoImg.src = qrCode.logo;
        } else {
          // If it's a relative path, add the origin
          logoImg.src = `${window.location.origin}${qrCode.logo}`;
        }
      } else {
        // No logo, just finish the download
        finishDownload();
      }
      
      // Helper function to add URL and trigger download
      function finishDownload() {
        // Load a web font for better text rendering
        const fontFamily = "'Roboto', 'Arial', sans-serif";
        
        console.log("QR code values in finishDownload:", {
          name: qrCode.qr_name,
          showName: qrCode.showName,
          showURL: qrCode.showURL,
          shape: qrCode.shape,
          qrType: qrCode.qrType  // Check the qrType
        });
        if (account && account.plan === 'free_basic') {
          setUpgradeModalType('download');
          setUpgradeModalOpen(true);
        }
        
        // More strict checking of boolean values
        // Convert string 'true'/'false' to boolean
        const isShowNameEnabled = 
          qrCode.showName === true || 
          String(qrCode.showName).toLowerCase() === "true";
          
        const isShowURLEnabled = 
          qrCode.showURL === true || 
          String(qrCode.showURL).toLowerCase() === "true";
        
        console.log("Display settings:", { isShowNameEnabled, isShowURLEnabled });
        
        // Calculate positions - adjust if only one is showing
        let namePosition = baseSize - 100;
        let urlPosition = baseSize - 50;
        
        // Only show name if enabled
        if (isShowNameEnabled && qrCode.qr_name) {
          // Limit the name to 25 characters with ellipsis if longer
          const maxNameLength = 25;
          const displayName = qrCode.qr_name.length > maxNameLength 
            ? qrCode.qr_name.substring(0, maxNameLength) + '...' 
            : qrCode.qr_name;
            
          console.log("Displaying name:", displayName);
            
          ctx.fillStyle = textColor;
          ctx.font = `bold 48px ${fontFamily}`;
          ctx.textAlign = 'center';
          // Apply anti-aliasing techniques
          ctx.textBaseline = 'middle';
          ctx.shadowColor = textColor;
          ctx.shadowBlur = 0;
          ctx.lineWidth = 1;
          ctx.fillText(displayName, baseSize/2, namePosition);
        }
        
        // Only show URL if enabled
        if (isShowURLEnabled) {
          // Determine what to display as the URL text
          let displayText = "";
          
          // For vCard, display a friendly "Contact Card" message or contact name
          if (qrCode.qrType === 'vcard') {
            displayText = qrCode.displayText || 'Contact Card';
          }
          // Use the original target URL if it exists (not the shortId URL)
          else if (qrCode.targetUrl) {
            // For phone numbers (format: tel:+1234567890)
            if (qrCode.targetUrl.startsWith('tel:')) {
              displayText = qrCode.targetUrl.substring(4); // Remove 'tel:' prefix
            } 
            // For SMS (format: sms:+1234567890)
            else if (qrCode.targetUrl.startsWith('sms:')) {
              displayText = qrCode.targetUrl.substring(4); // Remove 'sms:' prefix
            }
            // For email (format: mailto:user@example.com)
            else if (qrCode.targetUrl.startsWith('mailto:')) {
              displayText = qrCode.targetUrl.substring(7); // Remove 'mailto:' prefix
            }
            // For plain text (not a URL)
            else if (qrCode.qrType === 'text') {
              // If it's text content, just use it directly (truncated if needed)
              const maxTextLength = 40;
              displayText = qrCode.targetUrl.length > maxTextLength 
                ? qrCode.targetUrl.substring(0, maxTextLength) + '...' 
                : qrCode.targetUrl;
            }
            // For regular URLs
            else {
              displayText = qrCode.targetUrl;
            }
          } else {
            // Default to the short URL if no specific target
            displayText = `${window.location.origin}/${qrCode.shortId}`;
          }
          
          console.log("Displaying URL/text:", displayText);
          
          // Draw the URL/text - use a slightly larger font size for better readability
          ctx.fillStyle = textColor;
          const urlFontSize = Math.floor(baseSize * 0.04); // A bit larger for better readability
          ctx.font = `${urlFontSize}px ${fontFamily}`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.shadowColor = textColor;
          ctx.shadowBlur = 0;
          ctx.lineWidth = 1;
          ctx.fillText(displayText, baseSize/2, urlPosition);
        }
        
        // Download
        const link = document.createElement('a');
        link.download = `${qrCode.qr_name || 'qrcode'}.png`;
        
        try {
          // Get the high-resolution image data
          link.href = canvas.toDataURL('image/png');
          // Append to DOM before clicking (helps with some browsers)
          document.body.appendChild(link);
          link.click();
          // Clean up after download initiated
          setTimeout(() => document.body.removeChild(link), 100);
        } catch (err) {
          console.error("Canvas toDataURL error:", err);
          alert("Could not generate download. Check console for details.");
        }
      }
    });
  } catch (error) {
    console.error("Download error:", error);
    alert("Error generating QR code");
  }
};

  const handleDownloadBulkQRs = async (bulkId) => {
    try {
      trackEvent('bulk_qr_download', {
        bulk_id: bulkId
      });
      // Show a loading indicator
      setIsDownloading(true);
      const loadingMsg = 'Preparing download...';
      console.log(loadingMsg);
      
      // First, fetch the bulk group data to get all QR codes
      const response = await fetch(`/api/bulk-qrcodes/${bulkId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch bulk QR codes');
      }
      
      const bulkGroup = await response.json();
      console.log('Bulk group data:', bulkGroup);
      
      if (!bulkGroup.qrCodes || bulkGroup.qrCodes.length === 0) {
        alert('No QR codes found in this group');
        return;
      }
      
      // Create a zip file with all QR codes
      const zip = new JSZip();
      const folder = zip.folder(bulkGroup.name || 'qr_codes');
      
      // Create a container div for QR codes
      const container = document.createElement('div');
      container.style.display = 'none';
      document.body.appendChild(container);
      
      // Process each QR code
      for (let i = 0; i < bulkGroup.qrCodes.length; i++) {
        const qrCode = bulkGroup.qrCodes[i];
        
        try {
          console.log(`Processing QR code ${i+1}/${bulkGroup.qrCodes.length}:`, {
            name: qrCode.qr_name,
            logo: qrCode.logo
          });
          
          // MATCH SINGLE QR EXPORT: Use same scaling approach
          const scaleFactor = 2;
          const baseSize = 800;
          const size = baseSize * scaleFactor;
          
          const canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          
          // Enable high-quality image smoothing
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          
          // Scale all drawing operations 
          ctx.scale(scaleFactor, scaleFactor);
          
          // Get styling info - use same property fallbacks as single QR
          const shape = qrCode.shape || bulkGroup.shape || 'square';
          const dotStyle = qrCode.dotStyle || shape;
          const bgColor = qrCode.backgroundColor || bulkGroup.backgroundColor || '#f1f1f4';
          const fgColor = qrCode.foregroundColor || bulkGroup.foregroundColor || '#000000';
          const textColor = qrCode.textColor || bulkGroup.textColor || '#000000';
          
          // Check boolean properties
          const isShowNameEnabled = 
            qrCode.showName === true || 
            String(qrCode.showName).toLowerCase() === "true";
            
          const isShowURLEnabled = 
            qrCode.showURL === true || 
            String(qrCode.showURL).toLowerCase() === "true";
          
          // Draw background with shape - exactly as in single QR
          ctx.fillStyle = bgColor;
          if (shape === 'circle') {
            ctx.beginPath();
            ctx.arc(baseSize/2, baseSize/2, baseSize/2, 0, Math.PI * 2);
            ctx.fill();
          } else if (shape === 'rounded') {
            const radius = baseSize / 10;
            ctx.beginPath();
            ctx.moveTo(radius, 0);
            ctx.lineTo(baseSize - radius, 0);
            ctx.quadraticCurveTo(baseSize, 0, baseSize, radius);
            ctx.lineTo(baseSize, baseSize - radius);
            ctx.quadraticCurveTo(baseSize, baseSize, baseSize - radius, baseSize);
            ctx.lineTo(radius, baseSize);
            ctx.quadraticCurveTo(0, baseSize, 0, baseSize - radius);
            ctx.lineTo(0, radius);
            ctx.quadraticCurveTo(0, 0, radius, 0);
            ctx.fill();
          } else {
            ctx.fillRect(0, 0, baseSize, baseSize);
          }
          
          // Get QR code data via temporary canvas - match single QR approach
          const tempCanvas = document.createElement('canvas');
          
          await new Promise((resolve) => {
            qrcode.toCanvas(
              tempCanvas, 
              `${window.location.origin}/${qrCode.shortId}`, 
              {
                errorCorrectionLevel: 'H',
                margin: 0, 
                scale: 1,
                width: 100  // Small size to get data
              }, 
              (error) => {
                if (error) {
                  console.error(`QR generation error for QR ${i+1}:`, error);
                  resolve();
                  return;
                }
                
                // Get QR code data
                const tempCtx = tempCanvas.getContext('2d');
                const qrData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
                const data = qrData.data;
                const moduleCount = tempCanvas.width;
                
                // Calculate dot size based on canvas size - match single QR
                const moduleSize = Math.floor(baseSize * 0.7 / moduleCount);
                const startPoint = Math.floor((baseSize - (moduleCount * moduleSize)) / 2);
                
                // Draw custom dots
                ctx.fillStyle = fgColor;
                
                for (let y = 0; y < moduleCount; y++) {
                  for (let x = 0; x < moduleCount; x++) {
                    // Get pixel color (only check red channel since QR is black/white)
                    const pixelIndex = (y * moduleCount + x) * 4;
                    const isDark = data[pixelIndex] < 128;
                    
                    if (isDark) {
                      const xPos = startPoint + x * moduleSize;
                      const yPos = startPoint + y * moduleSize;
                      
                      // Draw based on selected dot style - match single QR
                      if (dotStyle === 'circle') {
                        // Draw circular dots
                        ctx.beginPath();
                        ctx.arc(
                          xPos + moduleSize / 2, 
                          yPos + moduleSize / 2, 
                          moduleSize / 2 * 0.9, // Slightly smaller for spacing
                          0, 
                          Math.PI * 2
                        );
                        ctx.fill();
                      } else if (dotStyle === 'rounded') {
                        // Draw rounded square dots
                        const radius = moduleSize / 4;
                        ctx.beginPath();
                        ctx.moveTo(xPos + radius, yPos);
                        ctx.lineTo(xPos + moduleSize - radius, yPos);
                        ctx.quadraticCurveTo(xPos + moduleSize, yPos, xPos + moduleSize, yPos + radius);
                        ctx.lineTo(xPos + moduleSize, yPos + moduleSize - radius);
                        ctx.quadraticCurveTo(xPos + moduleSize, yPos + moduleSize, xPos + moduleSize - radius, yPos + moduleSize);
                        ctx.lineTo(xPos + radius, yPos + moduleSize);
                        ctx.quadraticCurveTo(xPos, yPos + moduleSize, xPos, yPos + moduleSize - radius);
                        ctx.lineTo(xPos, yPos + radius);
                        ctx.quadraticCurveTo(xPos, yPos, xPos + radius, yPos);
                        ctx.fill();
                      } else {
                        // Default square dots
                        ctx.fillRect(xPos, yPos, moduleSize, moduleSize);
                      }
                    }
                  }
                }
                
                resolve();
              }
            );
          });
          
          // Process logo if present and valid
          const logoUrl = qrCode.logo;
          const isValidLogo = logoUrl && 
                            typeof logoUrl === 'string' && 
                            logoUrl !== 'null' && 
                            logoUrl !== 'undefined';
          
          if (isValidLogo) {
            await new Promise((resolve) => {
              const logoImg = new Image();
              logoImg.crossOrigin = "Anonymous";
              
              logoImg.onload = function() {
                // Calculate logo size and position - match single QR
                const logoSize = baseSize * 0.15; // 15% of QR code size
                const logoX = (baseSize - logoSize) / 2;
                const logoY = (baseSize - logoSize) / 2;
                
                // Use same padding approach as single QR
                const padding = size * 0.009; 
                ctx.fillStyle = bgColor;
                ctx.fillRect(
                  logoX - padding, 
                  logoY - padding, 
                  logoSize + (padding * 2), 
                  logoSize + (padding * 2)
                );
                
                // Draw logo
                ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize);
                console.log(`Logo successfully added to QR code ${i+1}`);
                resolve();
              };
              
              logoImg.onerror = function(e) {
                console.error(`Failed to load logo for QR code ${i+1}:`, logoUrl, e);
                resolve(); // Continue without logo
              };
              
              // Format URL the same way as single QR
              if (logoUrl.startsWith('http')) {
                logoImg.src = logoUrl;
              } else {
                // If it's a relative path, add the origin
                logoImg.src = `${window.location.origin}${logoUrl}`;
              }
              
              // Set a timeout to prevent hanging if image fails to load
              setTimeout(() => {
                console.warn(`Logo load timed out for QR code ${i+1}`);
                resolve(); // Continue without logo after timeout
              }, 5000);
            });
          }
          
          // Add text elements - use same formatting as single QR
          const fontFamily = "'Roboto', 'Arial', sans-serif";
          
          // Calculate positions the same way as single QR
          let namePosition = baseSize - 100;
          let urlPosition = baseSize - 50;
          
          // Add name if enabled - match single QR
          if (isShowNameEnabled && qrCode.qr_name) {
            // Limit the name to 25 characters with ellipsis if longer
            const maxNameLength = 25;
            const displayName = qrCode.qr_name.length > maxNameLength 
              ? qrCode.qr_name.substring(0, maxNameLength) + '...' 
              : qrCode.qr_name;
              
            console.log(`Displaying name for QR ${i+1}:`, displayName);
              
            ctx.fillStyle = textColor;
            ctx.font = `bold 48px ${fontFamily}`;
            ctx.textAlign = 'center';
            // Match anti-aliasing techniques
            ctx.textBaseline = 'middle';
            ctx.shadowColor = textColor;
            ctx.shadowBlur = 0;
            ctx.lineWidth = 1;
            ctx.fillText(displayName, baseSize/2, namePosition);
          }
          
          // Add URL if enabled - match single QR
          if (isShowURLEnabled) {
            // Determine what to display as the URL text
            let displayText = "";
            
            // Use the original target URL if it exists (not the shortId URL)
            if (qrCode.targetUrl) {
              // Same formatting as single QR
              if (qrCode.targetUrl.startsWith('tel:')) {
                displayText = qrCode.targetUrl.substring(4); // Remove 'tel:' prefix
              } else if (qrCode.targetUrl.startsWith('sms:')) {
                displayText = qrCode.targetUrl.substring(4); // Remove 'sms:' prefix
              } else if (qrCode.targetUrl.startsWith('mailto:')) {
                displayText = qrCode.targetUrl.substring(7); // Remove 'mailto:' prefix
              } else if (qrCode.qrType === 'text') {
                // If it's text content, just use it directly (truncated if needed)
                const maxTextLength = 40;
                displayText = qrCode.targetUrl.length > maxTextLength 
                  ? qrCode.targetUrl.substring(0, maxTextLength) + '...' 
                  : qrCode.targetUrl;
              } else {
                displayText = qrCode.targetUrl;
              }
            } else {
              // Default to the short URL if no specific target
              displayText = `${window.location.origin}/${qrCode.shortId}`;
            }
            
            // Match font size and text rendering from single QR
            ctx.fillStyle = textColor;
            const urlFontSize = Math.floor(baseSize * 0.025);
            ctx.font = `${urlFontSize}px ${fontFamily}`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.shadowColor = textColor;
            ctx.shadowBlur = 0;
            ctx.lineWidth = 1;
            ctx.fillText(displayText, baseSize/2, urlPosition);
          }
          
          // Create a filename 
          let fileName = '';
          if (qrCode.qr_name) {
            fileName = qrCode.qr_name.replace(/[^a-z0-9]/gi, '_');
          } else if (qrCode.slug) {
            fileName = qrCode.slug.replace(/[^a-z0-9]/gi, '_');
          } else {
            fileName = `qr_${qrCode.shortId}`;
          }
          
          // Add to ZIP
          const dataUrl = canvas.toDataURL('image/png');
          const base64Data = dataUrl.split(',')[1];
          folder.file(`${fileName}.png`, base64Data, { base64: true });
          console.log(`QR code ${i+1} added to ZIP: ${fileName}.png`);
        } catch (qrError) {
          console.error(`Error processing QR code ${i+1}:`, qrError);
          // Continue with next QR code
        }
      }
      
      // Clean up container
      document.body.removeChild(container);
      
      console.log('Generating ZIP file...');
      
      // Generate and download the ZIP file
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `${bulkGroup.name || 'qr_codes'}.zip`);
      
      setSuccess('QR codes downloaded successfully');
      console.log('Download completed');
    } catch (error) {
      console.error('Error downloading bulk QR codes:', error);
      alert('Error preparing QR codes for download. Please try again. Error: ' + error.message);
    } finally {
      setIsDownloading(false);
    }
  };


  const handleShareQR = async (qrCode) => {
    try {
      const shareUrl = qrCode.shortUrl || `${window.location.origin}/${qrCode.shortId}`;
      const shareTitle = qrCode.qr_name || 'My QR Code';
      const shareText = `Check out my QR code: ${shareTitle}`;
      
      // Check if the Web Share API is available
      if (navigator.share) {
        try {
          // Use basic URL sharing which is widely supported
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl
          });
          console.log('QR code shared successfully');
        } catch (error) {
          console.error('Error sharing:', error);
          // Fallback to clipboard if share fails
          copyToClipboard(shareUrl);
        }
      } else {
        // Fallback for browsers that don't support the Web Share API
        copyToClipboard(shareUrl);
      }
    } catch (error) {
      console.error('Error in share process:', error);
    }
  };
  
  
  // Helper function for clipboard fallback
  const copyToClipboard = (text) => {
    // Try to use clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => alert('Link copied to clipboard!'))
        .catch(err => {
          console.error('Could not copy to clipboard:', err);
          // Fallback for very old browsers
          fallbackCopyToClipboard(text);
        });
    } else {
      // Fallback for browsers without clipboard API
      fallbackCopyToClipboard(text);
    }
  };
  
  // Old-school clipboard fallback
  const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';  // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      alert('Link copied to clipboard!');
    } catch (err) {
      console.error('Fallback: Could not copy text: ', err);
      alert(`Copy this link manually: ${text}`);
    }
    
    document.body.removeChild(textArea);
  };

  // The updated fetchData function that focuses on account-based fetching
  useEffect(() => {
    const fetchData = async () => {
      // Skip fetching if user is not available yet
      if (!user) {
        console.log('User not initialized yet, skipping data fetch');
        return;
      }
  
      try {
        console.log('Fetching data for clerk ID:', user.id);
        
        // First, try to directly fetch the user's account
        console.log(`Finding user with clerk ID: ${user.id}`);
        try {
          const userResponse = await fetch(`/api/users/by-clerk/${user.id}`);
          
          if (userResponse.ok) {
            const userData = await userResponse.json();
            console.log('User data:', userData);
            
            if (userData && userData.account_id) {
              const accountId = userData.account_id;
              console.log(`Found account ID from user lookup: ${accountId}`);
              
              // Fetch account details
              const accountResponse = await fetch(`/api/account/${accountId}`);
              if (accountResponse.ok) {
                const accountData = await accountResponse.json();
                console.log('Account data successfully fetched:', accountData);
                setAccount(accountData);
                
                // Calculate days remaining if on free plan
                if (accountData.plan === 'free_trial') {
                  const creationDate = new Date(accountData.createdAt);
                  const currentDate = new Date();
                  const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                  const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                  setDaysRemaining(daysRemaining);
                  console.log('Days remaining on free plan:', daysRemaining);
                }
              }
            }
          }
        } catch (accountError) {
          console.error('Error fetching account:', accountError);
        }
        
        // Simplified approach - directly fetch resources by user ID first
        // This ensures we at least have content to show even if account lookup fails
        console.log('First trying direct user_id fetching for immediate results');
        
        const linkResponse = await fetch(`/api/linkshorts?user_id=${user.id}`);
        if (linkResponse.ok) {
          const linkData = await linkResponse.json();
          console.log(`Found ${linkData.length} link shorts with direct user_id method`);
          setLinkShorts(linkData);
          
          // If we have at least one link, try to get account from there
          if (linkData.length > 0 && linkData[0].account_id && !account) {
            const accountId = linkData[0].account_id;
            console.log(`Using account ID from link short: ${accountId}`);
            
            // Fetch account details
            const accountResponse = await fetch(`/api/account/${accountId}`);
            if (accountResponse.ok) {
              const accountData = await accountResponse.json();
              setAccount(accountData);
              
              // Calculate days remaining if on free plan
              if (accountData.plan === 'free_trial') {
                const creationDate = new Date(accountData.createdAt);
                const currentDate = new Date();
                const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                setDaysRemaining(daysRemaining);
              }
            }
          }
        }
        
        const qrResponse = await fetch(`/api/qrcodes?user_id=${user.id}`);
        if (qrResponse.ok) {
          const qrData = await qrResponse.json();
          console.log(`Found ${qrData.length} QR codes with direct user_id method`);
          setQrCodes(qrData);
          
          // If we have at least one QR code, try to get account from there
          if (qrData.length > 0 && qrData[0].account_id && !account) {
            const accountId = qrData[0].account_id;
            console.log(`Using account ID from QR code: ${accountId}`);
            
            // Fetch account details
            const accountResponse = await fetch(`/api/account/${accountId}`);
            if (accountResponse.ok) {
              const accountData = await accountResponse.json();
              setAccount(accountData);
              
              // Calculate days remaining if on free plan
              if (accountData.plan === 'free_trial') {
                const creationDate = new Date(accountData.createdAt);
                const currentDate = new Date();
                const timeDiff = (14 * 24 * 60 * 60 * 1000) - (currentDate - creationDate);
                const daysRemaining = Math.max(0, Math.ceil(timeDiff / (24 * 60 * 60 * 1000)));
                setDaysRemaining(daysRemaining);
              }
            }
          }
        }
        
        // Try to find all resources by account_id if user lookup succeeded
        try {
          // First check if we found the user successfully above
          const userResponse = await fetch(`/api/users/by-clerk/${user.id}`);
          if (userResponse.ok) {
            const userData = await userResponse.json();
            
            if (userData && userData.account_id) {
              const accountId = userData.account_id;
              
              // Try to fetch all resources by account_id
              const accountLinksResponse = await fetch(`/api/linkshorts?account_id=${accountId}`);
              if (accountLinksResponse.ok) {
                const accountLinksData = await accountLinksResponse.json();
                console.log(`Found ${accountLinksData.length} link shorts for account`);
                if (accountLinksData.length > 0) {
                  setLinkShorts(accountLinksData);
                }
              }
              
              const accountQrResponse = await fetch(`/api/qrcodes?account_id=${accountId}`);
              if (accountQrResponse.ok) {
                const accountQrData = await accountQrResponse.json();
                console.log(`Found ${accountQrData.length} QR codes for account`);
                if (accountQrData.length > 0) {
                  setQrCodes(accountQrData);
                }
              }
            }
          }
        } catch (userLookupError) {
          console.error('Error during user/account lookup:', userLookupError);
          // We already have data from direct user_id fetching, so no need to do anything else
        }
      } catch (err) {
        console.error('Error in fetchData:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }

      
      
      if (user && account) {
        try {
          const accountId = account._id;
          const bulkResponse = await fetch(`/api/bulk-qrcodes?account_id=${accountId}`);
          if (bulkResponse.ok) {
            const bulkData = await bulkResponse.json();
            console.log(`Found ${bulkData.length} bulk groups for account`);
            
            // Create a mapping of bulk group IDs to their names
            const bulkGroupsMapping = {};
            bulkData.forEach(group => {
              if (group._id && group.name) {
                bulkGroupsMapping[group._id] = group.name;
              }
            });
            
            // Store this mapping
            setBulkGroupsData(bulkGroupsMapping);
          }
        } catch (error) {
          console.error('Error fetching bulk groups:', error);
        }
      }

      if (account) {
        // const shouldDisableAll = 
        //   // Case 1: Free trial with 0 days remaining
        //   (account.plan === 'free_trial' && daysRemaining <= 0) || 
        //   // Case 2: Downgraded subscription past payment period
        //   (account.subscriptionStatus === 'downgraded' && 
        //    account.subscription?.currentPeriodEnd && 
        //    new Date(account.subscription.currentPeriodEnd) < new Date());
        //    if (user && account) {
        //     try {
        //       const accountId = account._id;
        //       const bulkResponse = await fetch(`/api/bulk-qrcodes?account_id=${accountId}`);
        //       if (bulkResponse.ok) {
        //         const bulkData = await bulkResponse.json();
        //         console.log(`Found ${bulkData.length} bulk groups for account`);
        //         setBulkGroupsData(bulkData);
        //       }
        //     } catch (error) {
        //       console.error('Error fetching bulk groups:', error);
        //     }
        //   }
          // setBulkGroup(data);
          // setQrCodes(data.qrCodes || []);
         
        
        
        // If we need to disable all items, make API calls to do so
        // if (shouldDisableAll) {
        //   console.log('Account expired or downgraded - disabling all QR codes and links');
          
        //   // This could be a single API endpoint that disables all for an account
        //   try {
        //     await fetch(`/api/account/${account._id}/disable-all-items`, {
        //       method: 'POST'
        //     });
            
        //     // Update UI to show all items as inactive
        //     setQrCodes(prevQrCodes => prevQrCodes.map(qr => ({...qr, isActive: false})));
        //     setLinkShorts(prevLinks => prevLinks.map(link => ({...link, isActive: false})));
        //   } catch (error) {
        //     console.error('Failed to disable all items:', error);
        //   }
        // }
      }
    };
    
    
    fetchData();
  }, [user]);

// In Dashboard.js - add to the handleCheckoutSuccess function
// In Dashboard.js - add this to your useEffect that handles the checkout success
useEffect(() => {
  const handleCheckoutSuccess = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const upgradeSuccess = urlParams.get('upgrade_success');
    
    if (upgradeSuccess === 'true') {
      // Check for pending upgrade in localStorage
      const pendingUpgradeStr = localStorage.getItem('pendingUpgrade');
      
      if (pendingUpgradeStr) {
        try {
          const pendingUpgrade = JSON.parse(pendingUpgradeStr);
          
          // Only process if less than 10 minutes old
          if (Date.now() - pendingUpgrade.timestamp < 10 * 60 * 1000) {
            console.log('Processing pending upgrade:', pendingUpgrade);
            
            // Make a direct API call to ensure plan is updated
            if (pendingUpgrade.plan === 'basic_plus') {
              // Use the specialized endpoint for basic_plus
              const upgradeResponse = await fetch('/api/account/upgrade-to-basic-plus', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  userId: pendingUpgrade.userId
                }),
              });
              
              if (upgradeResponse.ok) {
                console.log('Successfully applied Basic+ upgrade via direct API call');
              } else {
                console.error('Failed to apply Basic+ upgrade');
              }
            }
          }
        } catch (error) {
          console.error('Error processing pending upgrade:', error);
        } finally {
          // Clear the pending upgrade
          localStorage.removeItem('pendingUpgrade');
        }
      }
      
      // Show success message
      alert('Your subscription has been successfully activated! You can now access statistics for your QR codes.');
      
      // Clear URL parameters
      window.history.replaceState({}, document.title, window.location.pathname);
      
      // Refresh the account data
      if (user) {
        fetchData();
      }
    }
  };
  
  handleCheckoutSuccess();
}, []);

  useEffect(() => {
    const updatePlanFromURL = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const planParam = queryParams.get('update_plan');
      const accountIdParam = queryParams.get('account_id');
      
      if (planParam && accountIdParam) {
        console.log(`Plan update from URL: ${planParam} for account ${accountIdParam}`);
        
        try {
          const response = await fetch('/api/account/update-plan', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              accountId: accountIdParam,
              plan: planParam
            }),
          });
          
          if (response.ok) {
            console.log('Plan updated successfully from URL parameters');
            // Remove the query parameters
            window.history.replaceState({}, document.title, window.location.pathname);
            
            // Refresh account data
            try {
              const refreshAccountResponse = await fetch(`/api/account/${accountIdParam}`);
              if (refreshAccountResponse.ok) {
                const refreshedAccountData = await refreshAccountResponse.json();
                console.log('Account refreshed after plan update:', refreshedAccountData);
                setAccount(refreshedAccountData);
              }
            } catch (refreshError) {
              console.error('Error refreshing account data:', refreshError);
            }
          } else {
            console.error('Failed to update plan from URL parameters');
          }
        } catch (error) {
          console.error('Error updating plan from URL:', error);
        }
      }
    };
    
    updatePlanFromURL();
  }, []);

  const openStats = (item, type) => {
    if (type === 'qr' && item.qrType === 'vcard') {
      alert('Stats are not available for contact cards.');
      return;
    }
    if (account && account.plan === 'free_basic') {
      // Show upgrade modal instead of stats
      setUpgradeModalType('stats');
      setUpgradeModalOpen(true);
      return;
    }
    trackEvent('stats_view', {
      item_id: item._id,
      item_type: type,
      item_name: type === 'qr' ? (item.qr_name || 'Unnamed QR Code') : item.shortId
    });
    
    setSelectedItem(item);
    setStatsItemType(type);
    setStatsModalOpen(true);
  };

  const handleDeleteQR = async (id) => {
    if (window.confirm('Are you sure you want to delete this QR code? This action cannot be undone.')) {
      try {
        console.log(`Attempting to delete QR code with ID: ${id}`);
        
        const response = await fetch(`/api/qrcodes/${id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          console.error(`Server responded with status: ${response.status}`);
          const errorText = await response.text();
          console.error(`Error response: ${errorText}`);
          throw new Error(`Failed to delete QR code: ${response.status} ${errorText}`);
        }
        
        console.log('QR code deleted successfully');
        // Remove the deleted QR code from state
        setQrCodes(qrCodes.filter(qr => qr._id !== id));
      } catch (err) {
        console.error('Error deleting QR code:', err);
        alert(`Error deleting QR code: ${err.message}`);
      }
    }
  };
  
  const handleDeleteLink = async (id) => {
    if (window.confirm('Are you sure you want to delete this link? This action cannot be undone.')) {
      try {
        const response = await fetch(`/api/linkshorts/${id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          throw new Error('Failed to delete link');
        }
        
        // Remove the deleted link from state
        setLinkShorts(linkShorts.filter(link => link._id !== id));
      } catch (err) {
        console.error('Error deleting link:', err);
        alert('Error deleting link. Please try again.');
      }
    }
  };
  const handleDeleteBulkGroup = async (bulkId) => {
    if (window.confirm('Are you sure you want to delete this entire QR code group? This action cannot be undone and will delete all associated QR codes.')) {
      try {
        const response = await fetch(`/api/bulk-qrcodes/${bulkId}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          const errorMessage = errorData.error || 'Failed to delete bulk QR code group';
          throw new Error(errorMessage);
        }
        
        // Remove all QR codes with this bulk_id from state
        setQrCodes(qrCodes.filter(qr => qr.bulk_id !== bulkId));
        
        // Show success message
        alert('Bulk QR code group deleted successfully');
      } catch (err) {
        console.error('Error deleting bulk QR group:', err);
        alert(`Error deleting bulk QR code group: ${err.message}`);
      }
    }
  };

  const handleToggleQRStatus = async (id) => {
    try {
      const response = await fetch(`/api/qrcodes/${id}/toggle`, {
        method: 'PATCH'
      });
      
      if (!response.ok) {
        throw new Error('Failed to toggle QR code status');
      }
      
      setQrCodes(qrCodes.map(qr => 
        qr._id === id ? { ...qr, isActive: !qr.isActive } : qr
      ));
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  const handleToggleLinkStatus = async (id) => {
    try {
      const response = await fetch(`/api/linkshorts/${id}/toggle`, {
        method: 'PATCH'
      });
      
      if (!response.ok) {
        throw new Error('Failed to toggle link status');
      }
      
      setLinkShorts(linkShorts.map(link => 
        link._id === id ? { ...link, isActive: !link.isActive } : link
      ));
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };


    
    // Process bulk QR codes first if that filter is selected
    const filteredItems = () => {
      let items = [];
      
      // Process bulk QR codes first if that filter is selected
      if (filter === 'bulk' || filter === 'all') {
        // Group QR codes by bulk_id
        const bulkGroups = {};
        
        qrCodes.forEach(qr => {
          if (qr.bulk_id) {
            // Check if the group already exists before creating a new one
            if (!bulkGroups[qr.bulk_id]) {
              // Use the name from our bulk groups data if available
              const bulkName = bulkGroupsData[qr.bulk_id] || qr.bulk_name || 'Unnamed Bulk Group';
              
              bulkGroups[qr.bulk_id] = {
                _id: qr.bulk_id,
                type: 'bulk',
                name: nameMapping[qr.bulk_id] || qr.bulk_name || 'Bulk Group',
                count: 0,
                qrCodes: [],
                createdAt: qr.createdAt,
                totalVisits: 0                 
              };
            }
            bulkGroups[qr.bulk_id].count++;
            bulkGroups[qr.bulk_id].qrCodes.push(qr);
            
            // Still update from individual QR codes if we don't have the name from the API
            if (!bulkGroupsData[qr.bulk_id] && qr.bulk_name && qr.bulk_name.trim() !== '') {
              bulkGroups[qr.bulk_id].name = qr.bulk_name;
            }
          
            // Update this condition to properly set the bulk name
            if (qr.bulk_name && qr.bulk_name.trim() !== '') {
              bulkGroups[qr.bulk_id].name = qr.bulk_name;
            }
            
            bulkGroups[qr.bulk_id].totalVisits += (qr.visits || 0);

            // Use the newest creation date for the group
            if (new Date(qr.createdAt) > new Date(bulkGroups[qr.bulk_id].createdAt)) {
              bulkGroups[qr.bulk_id].createdAt = qr.createdAt;
            }
          
          }
        });
      
      // Add bulk groups to items
      items = [...items, ...Object.values(bulkGroups)];
    }
    
    // Add individual QR codes if not in bulk filter
    if ((filter === 'qr' || filter === 'all') && filter !== 'bulk') {
      // Add QR codes that are not part of a bulk group
      const individualQrCodes = qrCodes
        .filter(qr => !qr.bulk_id)
        .map(item => ({ ...item, type: 'qr' }));
      
      items = [...items, ...individualQrCodes];
    }
    
    // Add link shorts if needed
    if (filter === 'links' || filter === 'all') {
      items = [...items, ...linkShorts.map(item => ({ ...item, type: 'link' }))];
    }
    
    return items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  };

  // Show loading state
  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  // Show error state
  if (error) {
    return <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>;
  }

  return (
    <div>

      {account && (
        // (account.plan === 'free_trial' && daysRemaining <= 0) || 
        (account.subscriptionStatus === 'canceled' && 
         account.subscription?.currentPeriodEnd && 
         new Date(account.subscription.currentPeriodEnd) < new Date())
      ) ? (
        // Red banner for expired accounts
        <div className="bg-red-50 border-t border-b border-red-100 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw] p-4 mb-6">
          <div className="max-w-4xl mx-auto px-3 sm:px-0">
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="mb-4 sm:mb-0 text-center sm:text-left">
                <h3 className="text-lg font-semibold text-red-800">Account Expired</h3>
                <p className="text-red-700">
                  Your QR codes and links have been deactivated. Upgrade now to reactivate them.
                </p>
              </div>
              <Link 
                to="/upgrade" 
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-medium transition duration-200"
              >
                Upgrade Now
              </Link>
            </div>
          </div>
        </div>
      // ) : account && account.plan === 'free_trial' && daysRemaining > 0 ? (
      //   // Blue banner for active free trial
      //   <div className="bg-blue-50 border-t border-b border-blue-100 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw] p-4 mb-6">
      //     <div className="max-w-4xl mx-auto px-3 sm:px-0">
      //       <div className="flex flex-col sm:flex-row items-center justify-between">
      //         <div className="mb-4 sm:mb-0 text-center sm:text-left">
      //           <h3 className="text-lg font-semibold text-blue-800">Trial Plan Limitations</h3>
      //           <p className="text-blue-700">
      //             Your QR codes and links are only active for {daysRemaining} more day{daysRemaining !== 1 ? 's' : ''}.
      //             Upgrade now to keep them active.
      //           </p>
      //         </div>
      //         <Link 
      //           to="/upgrade" 
      //           className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition duration-200"
      //         >
      //           Upgrade Now
      //         </Link>
      //       </div>
      //     </div>
      //   </div>
      ) : null}

      <div className="mt-6 max-w-4xl mx-auto px-3 sm:px-0">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-0">My Dashboard</h1>

          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
            <Link 
              to="/create-link" 
              className="bg-white border border-2 border-gray-900 hover:bg-gray-200 text-gray-900 px-4 py-2 rounded font-medium transition duration-200 text-center"
            >
              Create Trackable Link
            </Link>
            <Link 
              to="/create" 
              className="bg-gray-900 hover:bg-gray-600 text-white px-4 py-2 rounded font-medium transition duration-200 text-center"
            >
              Create QR Code
            </Link>
          </div>
        </div>



        <div className="mb-6 border rounded-lg overflow-hidden">
          <div className="flex flex-wrap">
            <button 
              className={`py-2 px-3 sm:py-3 sm:px-4 font-medium text-sm sm:text-base flex-grow ${filter === 'all' ? 'bg-gray-100' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button 
              className={`py-2 px-3 sm:py-3 sm:px-4 font-medium text-sm sm:text-base flex-grow ${filter === 'qr' ? 'bg-gray-100' : ''}`}
              onClick={() => setFilter('qr')}
            >
              QR Codes
            </button>
            <button 
              className={`py-2 px-3 sm:py-3 sm:px-4 font-medium text-sm sm:text-base flex-grow ${filter === 'links' ? 'bg-gray-100' : ''}`}
              onClick={() => setFilter('links')}
            >
              Links
            </button>
            
            <button 
              className={`py-2 px-3 sm:py-3 sm:px-4 font-medium text-sm sm:text-base flex-grow ${filter === 'bulk' ? 'bg-gray-100' : ''}`}
              onClick={() => setFilter('bulk')}
            >
              Bulk Groups
            </button>
          </div>
        </div>

        <div className="space-y-6">
          {filteredItems().length === 0 ? (
            <div className="text-center py-10 text-gray-500">
              No items found. Create your first QR code or link short to get started.
            </div>
          ) : (
            filteredItems().map(item => (
              <div key={item._id} className="bg-white rounded-lg overflow-hidden shadow-sm">
    
{item.type === 'bulk' ? (
  // Render bulk group
  <div className="flex flex-col sm:flex-row p-3 sm:p-4">
    <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto sm:mx-0 sm:mr-4 flex items-center justify-center bg-blue-50 rounded relative mb-3 sm:mb-0">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-700" viewBox="0 0 20 20" fill="currentColor">
        <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
      </svg>
      <div className="flex flex-col absolute mt-14 items-center justify-center text-blue-700 text-xs font-bold">
        +{item.count} QRs
      </div>
    </div>
    
    <div className="flex-1 text-center sm:text-left">
      <div className="flex flex-col sm:flex-row sm:items-center justify-center sm:justify-start mb-2">
        <h2 className="text-lg sm:text-xl font-semibold">
          {item.name}
        </h2>
        <span className="mt-1 sm:mt-0 sm:ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full self-center">
          Bulk Group
        </span>
      </div>
      
      <p className="text-gray-600 text-sm sm:text-base">
        Contains {item.count} QR codes
      </p>
      
      <div className="mt-1 mb-1 text-xs sm:text-sm text-gray-500">
        Views: {item.totalVisits || 0} | Created: {new Date(item.createdAt).toLocaleDateString()}
      </div>
      
      <div className="flex justify-center sm:justify-start space-x-8">
      <button
  onClick={() => openBulkStats(item)}
  className="text-blue-600 hover:underline font-medium text-sm"
>
  View Stats
</button>
<button 
  className="text-green-600 hover:text-green-800 text-sm font-medium"
  onClick={() => handleDownloadBulkQRs(item._id)}

  disabled={isDownloading}
>
  {isDownloading ? 'Downloading...' : 'Download All'}
</button>
        <Link 
          to={item._id ? `/bulk-edit/${item._id}` : '#'} 
          className={`text-gray-400 hover:underline font-medium text-sm ${!item._id ? 'cursor-not-allowed opacity-50' : ''}`}
          onClick={(e) => {
            if (!item._id) {
              e.preventDefault();
              alert('Cannot edit this group: Missing group ID');
            }
          }}
        >
          Edit Group
        </Link>
        <button
          onClick={() => handleDeleteBulkGroup(item._id)}
          className="text-gray-400 hover:underline font-medium text-sm"
        >
          Delete Group
        </button>
      </div>
    </div>
  </div>
) : (
                  // Render individual QR code or link
                  <div className="bg-white flex flex-col shadow-md sm:flex-row p-3 sm:p-4">
                    {/* QR code or Link icon - with fixed positioning */}
                    {item.type === 'qr' ? (
                      <div 
                        data-qr-id={item._id}
                        className="w-20 h-20 sm:w-24 sm:h-24 mx-auto sm:mx-0 sm:mr-4 p-2 rounded relative mb-3 sm:mb-0 flex items-center justify-center"
                        style={{
                          backgroundColor: item.backgroundColor || '#f1f1f4'
                        }}
                      >
                        <QRCode
                          value={`${window.location.origin}/${item.shortId}`}
                          size={72}
                          fgColor={item.foregroundColor || '#000000'}
                          bgColor="transparent"
                          level="H"
                          renderAs="svg"
                          imageSettings={item.logo ? {
                            src: item.logo,
                            width: 20,
                            height: 20,
                            excavate: true
                          } : undefined}
                          // showName={item.showName}
                          // showURL={item.showURL}
                        />
                        <div className="absolute -right-2 -bottom-1 flex flex-col space-y-1">
                          {/* Download button - hidden on mobile, visible on SM and up */}
                          <button 
                            onClick={() => handleDownloadQR(item)}
                            className="hidden sm:block bg-blue-500 text-white rounded-full p-1 hover:bg-blue-600"
                            title="Download QR Code"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </button>
                          
                          {/* Share button - visible on mobile only, hidden on SM and up */}
                          <button 
                            onClick={() => handleShareQR(item)}
                            className="sm:hidden bg-green-500 text-white rounded-full p-1 hover:bg-green-600"
                            title="Share QR Code"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                            </svg>
                          </button>
                        </div>
                        
                      </div>
                    ) : (
                      <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto sm:mx-0 sm:mr-4 flex items-center justify-center bg-gray-50 p-2 rounded mb-3 sm:mb-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 sm:h-10 sm:w-10 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 015.656 0l4 4a4 4 0 01-5.656 5.656l-1.102-1.101" />
                        </svg>
                      </div>
                    )}
                    
                    {/* Content area - reorganized for mobile */}
                    <div className="flex-1 text-center sm:text-left">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-center sm:justify-start mb-2">
                        <h2 className="text-lg sm:text-xl font-semibold">
                          {item.type === 'qr' ? (item.qr_name || 'Unnamed QR Code') : item.shortId}
                        </h2>
                        <span className="mt-1 sm:mt-0 sm:ml-2 px-2 py-1 text-xs bg-gray-100 rounded-full self-center">
                          {item.type === 'qr' ? 'QR Code' : 'Link Short'}
                        </span>
                      </div>
                      
                      {item.type === 'link' && (
                        <p className="text-gray-600 text-sm sm:text-base mt-1">
                          <span className="font-medium block sm:inline">URL: {window.location.origin}/{item.shortId}</span>
                          <button 
                            onClick={() => {
                              navigator.clipboard.writeText(`${window.location.origin}/${item.shortId}`);
                              alert('Link copied to clipboard!');
                            }}
                            className="ml-2 text-blue-500 hover:text-blue-700 text-sm"
                          >
                            Copy
                          </button>
                          <p className="text-gray-300 text-xs sm:text-sm overflow-hidden text-ellipsis">
                            Redirects to: {item.targetUrl.length > 40 ? `${item.targetUrl.substring(0, 40)}...` : item.targetUrl}
                          </p>
                        </p>
                      )}
                      
                      {item.type === 'qr' && (
                        <p className="text-gray-600 text-sm sm:text-base overflow-hidden text-ellipsis">
                        Redirects to: 
                        <span className="block sm:inline ml-0 sm:ml-1 overflow-hidden text-ellipsis">
                          {item.qrType === 'vcard' ? (
                            'Contact Card'
                          ) : (
                            item.targetUrl.length > 30 ? 
                              `${item.targetUrl.substring(0, 30)}...` : 
                              item.targetUrl
                          )}
                        </span>
                        </p>
                        )}

{/* {item.type === 'qr' && item.qrType === 'vcard' && (
  <div className="mt-1 mb-1 text-xs bg-yellow-100 text-yellow-800 p-2 rounded">
    <span className="font-medium">Note:</span> Stats not available for contact cards.
  </div>
)} */}

                      <div className="mt-1 mb-1 text-xs sm:text-sm text-gray-500">
                      Views: {item.type === 'qr' && item.qrType === 'vcard' ? 'N/A' : (item.visits || 0)} | Created: {new Date(item.createdAt).toLocaleDateString()}
                      </div>
                      <div className="flex justify-center sm:justify-start space-x-8">
                        <button
                          onClick={() => openStats(item, item.type)}
                          className="text-blue-600 hover:underline font-medium text-sm"
                        >
                          View Stats
                        </button>
                        {item.type === 'qr' && (
    <button
      onClick={() => handleDownloadQR(item)}
      className="text-green-600 hover:text-green-800 text-sm font-medium"
    >
      Download
    </button>
  )}
                        
                        <Link 
                          to={item.type === 'qr' ? `/edit/${item._id}` : `/edit-link/${item._id}`} 
                          className="text-gray-400 hover:underline font-medium text-sm"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() => item.type === 'qr' 
                            ? handleDeleteQR(item._id) 
                            : handleDeleteLink(item._id)
                          }
                          className="text-gray-400 hover:underline font-medium text-sm"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                    
                    {/* Status toggle - moved to bottom on mobile */}
                    <div className="mt-3 sm:mt-0 sm:ml-4 flex items-center justify-center sm:justify-start">
                      <span className="mr-2 text-sm sm:text-base">{item.isActive ? 'Live' : 'Inactive'}</span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input 
                          type="checkbox" 
                          className="sr-only peer"
                          checked={item.isActive}
                          onChange={() => item.type === 'qr' 
                            ? handleToggleQRStatus(item._id) 
                            : handleToggleLinkStatus(item._id)
                          }
                        />
                        <div className="w-9 h-5 sm:w-11 sm:h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 sm:after:h-5 sm:after:w-5 after:transition-all peer-checked:bg-black"></div>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      <UpgradeModal 
        isOpen={upgradeModalOpen}
        onClose={() => setUpgradeModalOpen(false)}
        type={upgradeModalType}
      />

      <BulkQRStatsModal
  isOpen={bulkStatsOpen}
  onClose={() => setBulkStatsOpen(false)}
  bulkGroup={selectedBulkGroup}
  stats={bulkStats}
/>
      
      {/* Stats Modal */}
      <StatsModal 
        isOpen={statsModalOpen}
        onClose={() => setStatsModalOpen(false)}
        item={selectedItem}
        itemType={statsItemType}
      />
    </div>
  );
}

export default Dashboard;
// // client/src/pages/Dashboard.js
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import QRCode from 'qrcode.react';
// import { useUser } from '@clerk/clerk-react';

// function Dashboard() {
//   const [qrCodes, setQrCodes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [filter, setFilter] = useState('all'); // 'all', 'live', 'offline'
//   const { isSignedIn, user } = useUser();

//   useEffect(() => {
//     const fetchQRCodes = async () => {
//       try {
//         const userId = user ? user.id : "fixed_user_123";
//         console.log('Fetching QR codes for user ID:', userId);
        
//         const response = await fetch(`/api/qrcodes?user_id=${userId}`);
//         console.log('API response status:', response.status);
        
//         if (!response.ok) {
//           throw new Error(`Error fetching QR codes: ${response.statusText}`);
//         }
        
//         const data = await response.json();
//         console.log('Fetched QR codes:', data);
//         setQrCodes(data);
//       } catch (err) {
//         console.error('Error fetching QR codes:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchQRCodes();
  
  
//     if (isSignedIn) {
//       fetchQRCodes();
//     } else {
//       setLoading(false);
//     }
//   }, [isSignedIn, user]);

//   const handleToggleStatus = async (id) => {
//     try {
//       // Call the API to toggle the status
//       const response = await fetch(`/api/qrcodes/${id}/toggle`, {
//         method: 'PATCH'
//       });
      
//       if (!response.ok) {
//         throw new Error('Failed to toggle QR code status');
//       }
      
//       // Update the local state
//       setQrCodes(qrCodes.map(qr => 
//         qr._id === id ? { ...qr, isActive: !qr.isActive } : qr
//       ));
//     } catch (err) {
//       console.error('Error toggling status:', err);
//       // You might want to show an error message to the user
//     }
//   };

//   const filteredQRCodes = () => {
//     switch (filter) {
//       case 'live':
//         return qrCodes.filter(qr => qr.isActive);
//       case 'offline':
//         return qrCodes.filter(qr => !qr.isActive);
//       default:
//         return qrCodes;
//     }
//   };

//   // Show loading state
//   if (loading) {
//     return <div className="text-center py-10">Loading QR codes...</div>;
//   }

//   // Show error state
//   if (error) {
//     return <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>;
//   }

//   // Determine if user is newly registered
//   const isNewUser = isSignedIn && qrCodes.length === 0;

//   return (
//     <div>
//       <div className="max-w-4xl mx-auto">
//         <div className="flex justify-between items-center mb-6">
//           <h1 className="text-3xl font-bold">
//             {isNewUser ? "Welcome to BoxyQR!" : "My QR Codes"}
//           </h1>

//           <Link 
//             to="/create" 
//             className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium transition duration-200"
//           >
//             Create QR Code
//           </Link>
//         </div>

//         {!isNewUser && (
//           <div className="mb-6 border rounded-lg overflow-hidden">
//             <div className="flex border-b">
//               <button 
//                 className={`flex-1 py-3 px-4 font-medium ${filter === 'all' ? 'bg-gray-100' : ''}`}
//                 onClick={() => setFilter('all')}
//               >
//                 All
//               </button>
//               <button 
//                 className={`flex-1 py-3 px-4 font-medium ${filter === 'live' ? 'bg-gray-100' : ''}`}
//                 onClick={() => setFilter('live')}
//               >
//                 Live
//               </button>
//               <button 
//                 className={`flex-1 py-3 px-4 font-medium ${filter === 'offline' ? 'bg-gray-100' : ''}`}
//                 onClick={() => setFilter('offline')}
//               >
//                 Off-Line
//               </button>
//             </div>
//           </div>
//         )}

//         <div className="space-y-6">
//           {isNewUser ? (
//             <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
//               <h2 className="text-2xl font-semibold mb-4">Create your first QR code</h2>
//               <p className="mb-6">Generate a custom QR code for your business, event, or personal use in just a few clicks.</p>
              
//               <div className="bg-blue-50 p-6 rounded-lg mb-6">
//                 <h3 className="font-medium mb-2">With BoxyQR you can:</h3>
//                 <ul className="list-disc pl-5 space-y-1">
//                   <li>Create unlimited QR codes</li>
//                   <li>Customize with your logo and brand colors</li>
//                   <li>Track scans and analytics</li>
//                   <li>Update your QR code destination anytime</li>
//                 </ul>
//               </div>
              
//               <Link 
//                 to="/create" 
//                 className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium inline-block"
//               >
//                 Create Your First QR Code
//               </Link>
//             </div>
//           ) : filteredQRCodes().length === 0 ? (
//             <div className="text-center py-10 text-gray-500">
//               No QR codes found. Click "Create QR Code" to get started.
//             </div>
//           ) : (
//             filteredQRCodes().map(qrCode => (
//               <div key={qrCode._id} className="border rounded-lg overflow-hidden shadow-sm">
//                 <div className="flex items-center p-4">
//                   <div className="w-24 h-24 mr-6 bg-gray-50 p-2 rounded">
//                     <QRCode 
//                       value={`${window.location.origin}/${qrCode.shortId}`}
//                       size={80}
//                       renderAs="svg"
//                     />
//                   </div>
                  
//                   <div className="flex-1">
//                     <h2 className="text-xl font-semibold">{qrCode.qr_name || 'Unnamed QR Code'}</h2>
//                     <p className="text-gray-600">Redirects to: {qrCode.targetUrl}</p>
//                     <div className="mt-1 text-sm text-gray-500">
//                       Views: {qrCode.visits || 0} | Group: {qrCode.group || 'N/A'} | Created: {new Date(qrCode.createdAt).toLocaleDateString()}
//                     </div>
//                     <Link to={`/edit/${qrCode._id}`} className="text-blue-500 hover:underline mt-2 inline-block">
//                       Edit
//                     </Link>
//                   </div>
                  
//                   <div className="ml-4 flex items-center">
//                     <span className="mr-2">{qrCode.isActive ? 'Live QR Code' : 'Inactive'}</span>
//                     <label className="relative inline-flex items-center cursor-pointer">
//                       <input 
//                         type="checkbox" 
//                         className="sr-only peer"
//                         checked={qrCode.isActive}
//                         onChange={() => handleToggleStatus(qrCode._id)}
//                       />
//                       <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Dashboard;
//WORKING
// // client/src/pages/Dashboard.js
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import QRCode from 'qrcode.react';

// function Dashboard() {
//   const [qrCodes, setQrCodes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [filter, setFilter] = useState('all'); // 'all', 'live', 'offline'

//   useEffect(() => {
//         const fetchQRCodes = async () => {
//           try {
//             // Get the same user ID that was used to create QR codes
//             const userId = "fixed_user_123";            
//             console.log('Fetching QR codes for user ID:', userId);
            
//             // Fetch QR codes from the API
//             const response = await fetch(`/api/qrcodes?user_id=${userId}`);
            
//             if (!response.ok) {
//               throw new Error(`Error fetching QR codes: ${response.statusText}`);
//             }
            
//             const data = await response.json();
//             console.log('Fetched QR codes:', data);
//             setQrCodes(data);
//             setLoading(false);
//           } catch (err) {
//             console.error('Error fetching QR codes:', err);
//             setError(err.message);
//             setLoading(false);
//           }
//         };
      
//         fetchQRCodes();
//       }, []);
//   const handleToggleStatus = async (id) => {
//     try {
//       // Call the API to toggle the status
//       const response = await fetch(`/api/qrcodes/${id}/toggle`, {
//         method: 'PATCH'
//       });
      
//       if (!response.ok) {
//         throw new Error('Failed to toggle QR code status');
//       }
      
//       // Update the local state
//       setQrCodes(qrCodes.map(qr => 
//         qr._id === id ? { ...qr, isActive: !qr.isActive } : qr
//       ));
//     } catch (err) {
//       console.error('Error toggling status:', err);
//       // You might want to show an error message to the user
//     }
//   };

//   const filteredQRCodes = () => {
//     switch (filter) {
//       case 'live':
//         return qrCodes.filter(qr => qr.isActive);
//       case 'offline':
//         return qrCodes.filter(qr => !qr.isActive);
//       default:
//         return qrCodes;
//     }
//   };

//   // Show loading state
//   if (loading) {
//     return <div className="text-center py-10">Loading QR codes...</div>;
//   }

//   // Show error state
//   if (error) {
//     return <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>;
//   }

//   return (
//     <div>
// <div className="max-w-4xl mx-auto">
//   <div className="flex justify-between items-center mb-6">
//     <h1 className="text-3xl font-bold">My QR Codes</h1>

//         <Link 
//           to="/create" 
//           className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium transition duration-200"
//         >
//           Create QR Code
//         </Link>
//       </div>

//       <div className="mb-6 border rounded-lg overflow-hidden">
//         <div className="flex border-b">
//           <button 
//             className={`flex-1 py-3 px-4 font-medium ${filter === 'all' ? 'bg-gray-100' : ''}`}
//             onClick={() => setFilter('all')}
//           >
//             All
//           </button>
//           <button 
//             className={`flex-1 py-3 px-4 font-medium ${filter === 'live' ? 'bg-gray-100' : ''}`}
//             onClick={() => setFilter('live')}
//           >
//             Live
//           </button>
//           <button 
//             className={`flex-1 py-3 px-4 font-medium ${filter === 'offline' ? 'bg-gray-100' : ''}`}
//             onClick={() => setFilter('offline')}
//           >
//             Off-Line
//           </button>
//         </div>
//       </div>

//       <div className="space-y-6">
//         {filteredQRCodes().length === 0 ? (
//           <div className="text-center py-10 text-gray-500">
//             No QR codes found. Click "Create QR Code" to get started.
//           </div>
//         ) : (
//           filteredQRCodes().map(qrCode => (
//             <div key={qrCode._id} className="border rounded-lg overflow-hidden shadow-sm">
//               <div className="flex items-center p-4">
//                 <div className="w-24 h-24 mr-6 bg-gray-50 p-2 rounded">
//                 <QRCode 
//                 value={`${window.location.origin}/${qrCode.shortId}`}
//                 size={80}
//                 renderAs="svg"
//                 />
//                 </div>
                
//                 <div className="flex-1">
//                   <h2 className="text-xl font-semibold">{qrCode.qr_name || 'Unnamed QR Code'}</h2>
//                   <p className="text-gray-600">Redirects to: {qrCode.targetUrl}</p>
//                   <div className="mt-1 text-sm text-gray-500">
//                     Views: {qrCode.visits || 0} | Group: {qrCode.group || 'N/A'} | Created: {new Date(qrCode.createdAt).toLocaleDateString()}
//                   </div>
//                   <Link to={`/edit/${qrCode._id}`} className="text-blue-500 hover:underline mt-2 inline-block">
//                     Edit
//                   </Link>
//                 </div>

                
//                 <div className="ml-4 flex items-center">
//                   <span className="mr-2">{qrCode.isActive ? 'Live QR Code' : 'Inactive'}</span>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input 
//                       type="checkbox" 
//                       className="sr-only peer"
//                       checked={qrCode.isActive}
//                       onChange={() => handleToggleStatus(qrCode._id)}
//                     />
//                     <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
//                   </label>
//                 </div>
//               </div>
//               </div>

            
//           ))
//         )}
//       </div>
//       </div>
//     </div>

//   );
// }

// export default Dashboard;